import { Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Store } from '@ngrx/store';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { getUsersLoggedIn } from '@collections/users';
import { AuthService } from '@core/auth';
import { LayoutConfig, LayoutPrivileges } from '@layout/layout.abstract.config';
import { User } from '@shared';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { appConfig } from '@app/app.config';

@Component({
  selector: 'mojo-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent {
  @ViewChild(MatSidenav) sideNav: MatSidenav;

  currentUser$: Observable<User> = this.store.select(getUsersLoggedIn);
  initials$: Observable<string> = this.currentUser$.pipe(
    filter((currentUser) => !!currentUser),
    map((currentUser) => currentUser.firstName[0] + currentUser.lastName[0]),
  );
  avatarPhotoShape = AvatarShapes.circle;
  avatarBackground = AvatarBackgroundSizes.cover;
  privileges: LayoutPrivileges;
  talentPoolsPrivilege = appConfig.privileges.talentPools.view;
  talentPoolsFe = AppFeatureExtensions.TALENT_POOLS;
  apiKeyFE = AppFeatureExtensions.API_KEY;
  conversionAndRoiReport = AppFeatureExtensions.CONVERSION_AND_ROI_REPORT;
  usageReport = AppFeatureExtensions.USAGE_REPORT;
  projectsReport = AppFeatureExtensions.PROJECTS_REPORT;
  pbiReportFe = AppFeatureExtensions.IRP_PBI_REPORT;

  constructor(
    private store: Store<{}>,
    private layoutConfig: LayoutConfig,
    private authService: AuthService,
  ) {
    this.privileges = layoutConfig.privileges;
  }

  openMenu() {
    this.sideNav.open();
  }

  logout(event: any) {
    event.preventDefault();
    return this.authService.logout();
  }
}
